import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const EditProfileForm = ({ editData, setEditData, onSave, onCancel }) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="bio">Bio</Label>
        <Textarea
          id="bio"
          value={editData.bio}
          onChange={(e) => setEditData({ ...editData, bio: e.target.value })}
          placeholder="Tell us about yourself..."
          className="border-[#E4E4E7] min-h-[100px]"
          maxLength={200}
          data-testid="bio-input"
        />
        <p className="text-xs text-[#71717A]">{editData.bio.length}/200 characters</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="avatar">Avatar URL</Label>
        <Input
          id="avatar"
          value={editData.avatar}
          onChange={(e) => setEditData({ ...editData, avatar: e.target.value })}
          placeholder="https://example.com/avatar.jpg"
          className="border-[#E4E4E7]"
          data-testid="avatar-input"
        />
      </div>
      <div className="flex gap-2">
        <Button
          onClick={onSave}
          className="bg-[#0047FF] hover:bg-[#0037CC] text-white"
          data-testid="save-profile-button"
        >
          Save Changes
        </Button>
        <Button
          variant="outline"
          onClick={onCancel}
          className="border-[#E4E4E7]"
          data-testid="cancel-edit-button"
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};
